import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import UserHeader from "components/Headers/UserHeader.js";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";

const CreaRepresentante = () => {
  const [postVariable, setPostVariable] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const [options, setOptions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [archivo, setArchivo] = useState(null);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback-dev.azurewebsites.net/api/v1/ObtenerUsuarios",
    })
      .then((Response) => {
        const apiOptions = Response.data.map((item) => ({
          value: item.id,
          label: item.nombre,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire("Error", "No se pudo cargar la lista de usuarios.", "error");
      });
  }, []);

  const manejarCambioArchivo = (event) => {
    setArchivo(event.target.files[0]);
  };

  const subirArchivo = async (e) => {
    e.preventDefault();

    if (!postVariable || !postVariable.value) {
      Swal.fire("Campo requerido", "Seleccione un representante.", "warning");
      return;
    }

    if (!archivo) {
      Swal.fire(
        "Campo requerido",
        "Debe adjuntar un archivo de firma.",
        "warning"
      );
      return;
    }

    const formData = new FormData();
    formData.append("file", archivo);

    setLoading(true);
    try {
      Swal.fire({
        title: "Subiendo archivo...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.post(
        `https://contratosback-dev.azurewebsites.net/api/v1/CreaAprobadorLegal/${postVariable.value}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.fire("¡Éxito!", response.data, "success");
      closeModal();
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      Swal.fire("Error", "Hubo un problema al subir el archivo.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-primary btn-lg" onClick={handleOpenModalTest}>
        Nuevo
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Representante"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={subirArchivo}>
                    <h6 className="heading-small text-muted mb-4">
                      Seleccione el Representante
                    </h6>
                    <div className="pl-lg-4">
                      <FormGroup>
                        <Select
                          name="representante"
                          options={options}
                          classNamePrefix="select"
                          onChange={setPostVariable}
                          isDisabled={isLoading}
                        />
                      </FormGroup>
                      <h6 className="heading-small text-muted mb-4">
                        Adjunte la firma
                      </h6>
                      <input
                        type="file"
                        name="files"
                        className="btn btn-secondary"
                        onChange={manejarCambioArchivo}
                        disabled={isLoading}
                        accept=".png"
                      />
                      <hr />
                      <button
                        type="submit"
                        className="btn btn-primary btn-user btn-block"
                        disabled={isLoading}
                      >
                        {isLoading ? <Spinner size="sm" /> : "Guardar"}
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CreaRepresentante;
